import type {
    AddProductAndRemoveOldestMutationVariables,
    AddProductToWishlistMutationVariables,
    ChangeProductSizeInWishlistMutationVariables,
    ChangeQuantityInWishlistMutationVariables,
    RemoveProductFromWishlistMutationVariables,
} from "@graphql/generated/types";

import { updateMutation } from "../../helpers";
import { useStore } from "../../store";
import { useCommerceClient } from "@graphql/useCommerceClient";

export const useAddProductToWishlist = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.addProductToWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<AddProductToWishlistMutationVariables>(executeWithVariables, setData);
};

export const useAddProductAndRemoveOldestFromWishlist = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.addProductAndRemoveOldest;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<AddProductAndRemoveOldestMutationVariables>(
        executeWithVariables,
        setData
    );
};

export const useRemoveProductFromWishlist = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.removeProductFromWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<RemoveProductFromWishlistMutationVariables>(
        executeWithVariables,
        setData
    );
};

export const useUpdateProductQtyInWishlist = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.changeQuantityInWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<ChangeQuantityInWishlistMutationVariables>(executeWithVariables, setData);
};

export const useUpdateProductSizeInWishlist = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.changeProductSizeInWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<ChangeProductSizeInWishlistMutationVariables>(
        executeWithVariables,
        setData
    );
};
